import { Box, Tab, Tabs } from "@mui/material";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import { DASHBOARD_TABS } from "../../types";

import { MsActivitiesByRegionTab, PendingBksByLocTab, PendingBksBySegTab } from "./tabs";
import { tabState } from "../../recoil";
import { useRecoilState } from "recoil";

/**
 * Dashboard tab management component
 */
const DashboardTabsManager = () => {

    const { t } = useTranslation('booking');

    const [tab, setTab] = useRecoilState(tabState);

    const handleChangeTab = useCallback((event: React.SyntheticEvent, newValue: number) => {
        setTab(newValue);
    }, []);

    return (
        <Box px={2} pt={2}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tab} onChange={handleChangeTab}>
                    <Tab label={t('label.pendingBookingsByLocation')} />
                    <Tab label={t('label.pendingBookingsBySegmentAndCategory')}/>
                    <Tab label={t('label.mobilityStoreActivitiesForRegion')} />
                </Tabs>
            </Box>
            <Box py={0}>
                {tab === DASHBOARD_TABS.PENDING_BOOKINGS_BY_LOCATIONS &&
                    <PendingBksByLocTab />
                }
                {tab === DASHBOARD_TABS.PENDING_BOOKINGS_BY_SEGMENT_AND_CATEGORY &&
                    <PendingBksBySegTab />
                }
                {tab === DASHBOARD_TABS.MOBILITY_STORE_ACTIVITIES_FOR_REGION &&
                    <MsActivitiesByRegionTab />
                }
            </Box>
        </Box>
    )
};

export default DashboardTabsManager;
